import React from 'react'
import { useParams } from "react-router-dom";
import DOMPurify from 'dompurify';
import Header from './graphComponents/Header'
import Summary from './graphComponents/Summary'
import ErrorFallback from "../../ErrorFallback";
import { ErrorBoundary } from "react-error-boundary";
import config from "../../../../config/config";
import getYear from "../../../../utils/getYear";


import '../tables/DataTable.scss'
const Image = ({ serverdata, slug, tab, toggle }) => {
    const { year } = useParams();
    const stringReplace = ( origString) => { return origString.replace(/\s/g, "").replace(".", "").replace("/",""); }
    const imageData = () => {
        let volume = serverdata.volume === 'chronic-kidney-disease' ? "CKD" :
             serverdata.volume === 'end-stage-renal-disease' ? "ESRD" :
             serverdata.volume === 'end-stage-kidney-disease' ? "ESRD" :
             "Supplements";

        let tabname = tab ? "_" + stringReplace(tab) : "";
        let togglename = toggle ? "_" + stringReplace(toggle) : "";
        let figureName = stringReplace(serverdata.figureNumber) + tabname + togglename;

        const ImageUrl = `${config.baseUri}/FigureImages?year=${year}&volume=${volume}&figure=${figureName}`;

        return (
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <center>
                    <img className="figure-image" src={ImageUrl} alt={figureName}/>
                </center>
            </ErrorBoundary>
        );
    }

    if (tab || toggle)
    {
        return (
            <>
                <div className="py-4">
                    {imageData()}
                </div>
            </>
        )
    }

    return (
        <>
            <Header figureData={serverdata} slug={slug} />
            <div className="py-4">
                {imageData()}
            </div>
            {getYear() < 2025 && 
                <div className="data-source" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(serverdata.methods, { ADD_ATTR: ['target'] }) }}>
                </div>
            }
            <Summary figureData={serverdata} />
        </>
    )
}

export default Image
